"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = void 0;
const tslib_1 = require("tslib");
const address_1 = require("../helpers/address");
const helpers_1 = require("../helpers");
const constants_1 = require("../constants");
const populateIUser_1 = require("../utils/populateIUser");
const axiosUtil_1 = require("../utils/axiosUtil");
const get = options => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
  const {
    account,
    env = constants_1.default.ENV.PROD
  } = options || {};
  if (!(0, address_1.isValidPushCAIP)(account)) {
    throw new Error("Invalid address!");
  }
  const caip10 = (0, address_1.walletToPCAIP10)(account);
  const API_BASE_URL = (0, helpers_1.getAPIBaseUrls)(env);
  const requestUrl = "".concat(API_BASE_URL, "/v2/users/?caip10=").concat(caip10);
  return (0, axiosUtil_1.axiosGet)(requestUrl).then(response => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    if (response.data) {
      response.data.publicKey = yield (0, helpers_1.verifyProfileKeys)(response.data.encryptedPrivateKey, response.data.publicKey, response.data.did, response.data.wallets, response.data.verificationProof);
    }
    return (0, populateIUser_1.populateDeprecatedUser)(response.data);
  })).catch(err => {
    console.error("[Push SDK] - API ".concat(requestUrl, ": "), err);
    throw Error("[Push SDK] - API ".concat(requestUrl, ": ").concat(err));
  });
});
exports.get = get;
//# sourceMappingURL=getUser.js.map